import { useEffect } from 'react'
import classNames from 'classnames'

import { useContentOverflow } from '../../../hooks'
import Text from '../../Text'

import * as styles from './ClampingTextContentCSSClamp.module.css'

function ClampingTextContentCSSClamp({
  clamped,
  clampingLinesCount,
  fullText,
  setShowExpandButton,
  textClassName = styles.text,
}) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  useEffect(() => {
    if (clamped && overflow) {
      setShowExpandButton(true)
    }
  }, [clamped, overflow])

  const className = classNames(
    textClassName,
    styles.ClampingTextContentCSSClamp,
    {
      [styles.clamped]: clamped,
    }
  )

  return (
    <Text
      className={className}
      ref={setContentOverflowRef}
      style={{ '--clamping-text-lines': clampingLinesCount }}
    >
      {fullText}
    </Text>
  )
}

export default ClampingTextContentCSSClamp
